import React from 'react';
import PropTypes from 'prop-types';
import Destinations from 'components/Destinations';
import LoadDetails from 'components/LoadDetails';
import Price from 'components/Price';

const Offer = ({ className, offer, offerAmount, biddableOffer }) => {
  return (
    <div className={className} data-testid="offer">
      <div className="offer">
        <Destinations
          start_time_from={offer.start_time_from}
          start_time_to={offer.start_time_to}
          start_time_from_tz={offer.start_time_from_tz}
          start_time_to_tz={offer.start_time_to_tz}
          label_from={offer.label_from}
          country_from={offer.country_from}
          end_time_from={offer.end_time_from}
          end_time_to={offer.end_time_to}
          end_time_from_tz={offer.end_time_from_tz}
          end_time_to_tz={offer.end_time_to_tz}
          label_to={offer.label_to}
          country_to={offer.country_to}
          distance={offer.distance}
          stops={offer.stops.length}
          withStops
        />
        <LoadDetails
          numberOfItems={offer.max_equivalent_pallets}
          mass={offer.sum_weight}
          height={offer.item_height}
          extras={offer.extras}
          bottomAlign
        />
        <div className="offer__price-container">
          <Price
            isNegotiablePrice={biddableOffer}
            price={offerAmount}
            showPrice={parseFloat(offerAmount) > 0.0}
            currency={offer.currency}
          />
        </div>
      </div>
    </div>
  );
};

Offer.defaultProps = {
  biddableOffer: false
};

Offer.propTypes = {
  className: PropTypes.string,
  offer: PropTypes.object.isRequired,
  offerAmount: PropTypes.string.isRequired,
  biddableOffer: PropTypes.bool
};

export default Offer;
